import { render, staticRenderFns } from "./OfficialProgramManage.vue?vue&type=template&id=9621c55a&scoped=true"
import script from "./OfficialProgramManage.vue?vue&type=script&lang=js"
export * from "./OfficialProgramManage.vue?vue&type=script&lang=js"
import style0 from "./OfficialProgramManage.vue?vue&type=style&index=0&id=9621c55a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9621c55a",
  null
  
)

export default component.exports